import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { YARD360_PATHS } from "@/app/app-constants";

interface NavigationState {
  currentTab: string;
}

const initialState: NavigationState = {
  currentTab: YARD360_PATHS[0], // Set a default tab
};

export const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setCurrentTab: (state, action: PayloadAction<string>) => {
      state.currentTab = action.payload;
    },
  },
});

export const { setCurrentTab } = navigationSlice.actions;
export default navigationSlice.reducer;
